// extracted by mini-css-extract-plugin
export default {"recos":"w5-z","productCardOverride":"x5-z","rowHasBadge":"y5-z"};